<template>
  <div v-if="show" class="configuration">
    <div v-if="cnt_mul === 0" class="main_config__wrap">

      <div class="main_config">
        <div class="header">
          <div class="header__left">
            <p>{{ translate('cur_ver') }}: {{ ver }}</p>
            <p>{{ translate('device.config.main') }}: </p>
          </div>
          <div class="header__right">

            <p>
              {{ translate('user.one') }}:
              <router-link
                  v-if="this.$store.getters.getPermissions.permissionGod === true && username !== ''"
                  :to="'/usermanagment/users/@' + username"
              >
                {{ username }}
              </router-link>

              <span v-else>
                {{ username }}
              </span>
            </p>
            <p>
              {{ translate('config.ts') }}: {{ get_date(ts) }}
            </p>
          </div>
        </div>

        <textarea
          v-model="main"
          aria-label="main"
          :readonly="!this.$store.getters.getPermissions.editDeviceConfig"
        />

        <span v-if="this.$store.getters.getPermissions.editDeviceConfig" class="save_config">
          <button
            type="submit"
            class="mdi mdi-archive btn btn-success "
            @click.prevent="save_config"
          >
            {{ translate("save") }}
          </button>

          <button
              type="submit"
              class="mdi mdi-file-document btn btn-success "
              @click.prevent="show_documentatiom()"
          >
            {{ translate("config.documentation") }}
          </button>
              <!--button type="submit" class="mdi mdi-archive btn btn-info" @click.prevent="add_multi" >Добавить Multi Link</button-->
        </span>
      </div>

      <div class="history">
        <div class="device_adresses_wrap">
          <label>
            {{ translate('config.device_adresses') }}
          </label>
          <div class="device_adresses">
            <TextTable
              :all_data = "device_addresses"
              @update="load_conf"
            />
          </div>
        </div>


        <div class="config_profile_wrap">
          <label>
            {{ translate('config.config_profile_history') }}
          </label>
          <div class="config_profile">
            <TextTable
              :all_data = "config_profile"
              @update="load_conf"
            />
          </div>
        </div>

        <div class="device_config_wrap">
          <label>
            {{ translate('config.device_config_history') }}
          </label>
          <div class="device_config">

            <TextTable
                :all_data = "device_config"
            />
          </div>
        </div>

      </div>
    </div>
  </div>

  <div
    v-else-if="main===false"
    style="height: 100%"
  >
    {{ translate("file.no") }}
  </div>
  <div
    v-else
    style="height: 100%"
  >
    <div class="spinner">
      <scale-loader />
    </div>
  </div>
</template>

<script>
import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';
import ShowDocumentation from "@/views/Dashboard/common/Device/Device/ShowDocumentation.vue";

export default {
  name: 'Configuration',
  components: {
    TextTable
  },
  props: {
    fid: [Number, String] //FID
  },
  data () {
    return {
      show: false,
      ts: 0,
      ver: 0,
      main: '',
      username: '',
      multi: {},
      device_addresses: {},
      config_profile: {},
      device_config: {}
    }
  },

  computed: {
    cnt_mul () {
      return 0
    }
  },
  watch: {
    $route () {
      this.to_zero()
    },
    fid () {
      this.show = false
      this.load_conf()
    }
  },
  mounted () {
    this.to_zero()
  },
  methods: {
    restart_page(){
      window.open('#/device/'+this.fid+'/config', '_self')
    },
    to_zero () {
      let flag = true
      if (this.$route.params.to_zero === 'to_zero') {
        if (confirm('Обнулить версию конфигурации для ' + this.fid + ' ?')) {
          flag = false
          this.$http.v1.resetDeviceConfigVersion(this.fid, () => {
            this.load_conf()
          })
        }
        this.restart_page()
      }
      if (flag) {
        this.load_conf()
      }
    },
    load_conf () {
      this.show = false
      if (this.$route.name === 'device_section') {
        this.$http.v1.getDeviceConfig(this.fid, (response) => {
          this.ver = response.data.ver
          this.main = response.data.config.main
          this.config_profile = response.data.config_profile_history
          this.device_config = response.data.device_config_history
          this.device_addresses = response.data.device_addresses
          this.ts = response.data.ts
          this.username = response.data.username
          this.show = true
          this.multi = [] // Array.isArray(response.data.multi_instance) ? {} : response.data.multi_instance; this.show = true
        })
      }

    },
    save_config () {
      this.show = false
      this.$http.v1.saveDeviceConfig(this.fid, {fid: this.fid, config: {main: this.main, multi_instance: this.multi}}, (response) => {
        this.global_notify('info', this.translate('config.saved_success'))
        this.main = response.data.config.main
        this.multi = response.data.config.multi_instance
        this.ver = response.data.ver
        this.show = true
        this.config_profile = response.data.config_profile_history
        this.device_config = response.data.device_config_history
        this.device_addresses = response.data.device_addresses
        this.ts = response.data.ts
        this.username = response.data.username
      })
    },
    add_multi () {
      this.multi['multi_link_' + (this.cnt_mul + 1)] = ''
      this.multi = {...this.multi}
    },
    show_documentatiom(){
      this.$http.v1.getConfigDocumentation( (response) => {
        var t = this.$createElement(ShowDocumentation, {
          props: {
            documentation: response.data.documentation,
          },
          on: {close: () => {this.$modal.hide('rpc_modal') }}
        })
        let temp = { render () { return t } }
        this.$modal.show(temp, {}, {width: 1100, height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'rpc_modal'})
      })
    },
  }
}

</script>

<style lang='scss' scoped>
  .configuration{
    display: flex;
    flex-direction: column;
    overflow:hidden;
    height: 100%;
    .main_config{
      width: calc(60% - 20px);
      height: 100%;
      overflow: auto;
      display: flex;
      flex-direction: column;
      &__wrap{
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .history{
          height: 100%;
          width: 40%;
          .config_profile{
            height: calc(100% - 20px);
            &_wrap{
              height: calc(40% - 5px);
              margin-top: 5px;
              label{
                height: 20px;
                font-size: 14px;
                margin: 0;
              }
            }
          }
          .device_adresses{
            height: calc(100% - 20px);
            &_wrap{
              height: calc(20% - 5px);
              margin-top: 5px;
              label{
                height: 20px;
                font-size: 14px;
                margin: 0;
              }
            }
          }
          .device_config{
            height: calc(100% - 20px);
            &_wrap{
              height: 40%;
              margin-top: 5px;
              label{
                height: 20px;
                font-size: 14px;
                margin: 0;
              }
            }
          }
        }
      }
      .header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        p{
          margin: 0;
          font-size: 10px;
        }
        &__right{
          a{
            color: #66615b;
          }
        }
      }
      textarea{
        flex: 10;
        width: 100%;
        overflow: auto;
        font-size: 16px;
        line-height: 125%;
        &::-webkit-scrollbar{
          width: 10px;
        }
      }
    }
    .save_config{
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
    }
  }

  @media (max-width: 1400px) {
    .configuration{
      .main_config{
        width: 100%;
        height: 90%;
        &__wrap{
          display: block;
          overflow: auto;
          padding-right: 10px;
          &::-webkit-scrollbar{
            width: 10px;
          }
          .history{
            height: inherit;
            width: 100%;
            .config_profile{
              height: 90%;
              &_wrap{
                height: 70%;
              }
            }
            .device_config{
              height: 90%;
              &_wrap{
                height: 70%;
              }
            }
          }
        }
        textarea{
          height: 100%;
        }
      }
    }
  }
</style>
